import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=d4cf0cee&scoped=true"
import script from "./Database.vue?vue&type=script&lang=js"
export * from "./Database.vue?vue&type=script&lang=js"
import style0 from "./Database.vue?vue&type=style&index=0&id=d4cf0cee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cf0cee",
  null
  
)

export default component.exports